export default "__VITE_ASSET__XEBT5XYs__"